// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"58dbb4d0","649":"f422d56a","846":"fe59666a","940":"ce70cf4a","960":"7c246f25"}[chunkId] + ".chunk.js";
};